import { Reveal } from "@/components/Reveal";
import { LEARN_SKILLS } from "@/data/academy";
import { ArrowRight } from "lucide-react";

export default function WhatPeopleLearn() {
  return (
    <section className="bg-cream py-28 md:py-44" data-testid="learn-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="overline text-ochre mb-7">What you will learn</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light leading-tight text-charcoal">
              Practical skills. Real capability. Lasting impact.
            </h2>
            <p className="mt-8 text-charcoal/70 text-lg font-light leading-relaxed">
              SeedKeepers Academy develops practical capability that can be applied immediately.
              Participants leave with the knowledge, field experience and confidence to identify
              native species, plan collections, process and store seed, establish seed banks,
              support restoration projects and build native seed enterprises.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal>
            <h3 className="font-serif text-2xl md:text-3xl text-rainforest">What you'll be ready to deliver</h3>
            <p className="text-charcoal/60 font-light mt-2 mb-6">After completing a SeedKeepers program, participants may be able to:</p>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-1">
            {LEARN_SKILLS.map((s, i) => (
              <Reveal key={s} delay={(i % 2) * 0.05}>
                <div className="flex items-start gap-3 py-3 border-b border-charcoal/10">
                  <ArrowRight size={15} className="text-ochre mt-1.5 shrink-0" />
                  <span className="text-charcoal/80 font-light">{s}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
